import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#383FFF",
      "fill-rule": "evenodd",
      d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m0 2A8 8 0 1 0 8 0a8 8 0 0 0 0 16m1-9v5H7V7zm-1-.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }